import React, { createContext, useContext, useState } from 'react';

export const NotificationContext = createContext({});

export const useNotificationContext = () => useContext(NotificationContext);

const NotificationContextProvider = ({ children }) => {
  const [customMessage, setCustomMessage] = useState(null);
  const [shouldDisplay, setShouldDisplay] = useState(false);
  const [errorReason, setErrorReason] = useState(null);

  const notification = {
    message: customMessage || `Sorry, that didn’t work. Please try again.`,
    setCustomMessage,
    setShouldDisplay,
    shouldDisplay,
    errorReason,
    setErrorReason,
  };

  return (
    <NotificationContext.Provider value={notification}>
      {children}
    </NotificationContext.Provider>
  );
};

export default NotificationContextProvider;
